import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import StorageIcon from '@mui/icons-material/Storage';
import { ServerDeploymentDialogContent } from './ServerDeploymentDialogContent';
import { Server } from './Serverlist';

export interface ServerDeploymentDialogProps {
    server: Server | null;
    onClose: () => void;    
}

export const ServerDeploymentDialog: React.FC<ServerDeploymentDialogProps> = ({ server, onClose }) => {
    return (
        <Dialog
            open={Boolean(server)} 
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    maxHeight: '90vh'
                }
            }}
        >
            <DialogTitle sx={{
                px: 3,
                py: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #eaeaea'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <StorageIcon sx={{ color: 'primary.main', mr: 1.5 }} />
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'medium' }}>
                        {"Deployment " + server?.name}
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                <ServerDeploymentDialogContent server={server} onClose={onClose} />
            </DialogContent>
            <DialogActions sx={{
                px: 3,
                py: 2,
                borderTop: '1px solid #eaeaea'
            }}>
                <Button variant="outlined" onClick={onClose}>
                    Schließen
                </Button>
            </DialogActions>
        </Dialog>
    );
};